/**
 * Agentic FuturePath AI brand lockup, official logo + wordmark.
 * Use this everywhere instead of generic icons or emoji.
 *
 * Variants:
 *   <Logo />               full-color brand mark, default size (h-10)
 *   <Logo size="sm" />     small (h-7) , for header bars
 *   <Logo size="lg" />     large (h-16), for hero sections
 *   <Logo size="xl" />     extra-large (h-24), landing/onboarding heroes
 *   <Logo withWordmark />  brand mark + "FUTUREPATH AI" text lockup
 *   <Logo monoText />      hides the brand mark, shows just the wordmark (rare)
 */
import React from 'react';

const SIZE_MAP = {
  sm: 'h-7 w-7',
  md: 'h-10 w-10',
  lg: 'h-16 w-16',
  xl: 'h-24 w-24',
};

const TEXT_SIZE_MAP = {
  sm: 'text-sm',
  md: 'text-lg',
  lg: 'text-2xl',
  xl: 'text-3xl',
};

export default function Logo({
  size = 'md',
  withWordmark = false,
  monoText = false,
  className = '',
  textClassName = '',
}) {
  if (monoText) {
    return (
      <span
        data-testid="brand-wordmark"
        className={`font-bold tracking-[0.18em] bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-500 bg-clip-text text-transparent ${TEXT_SIZE_MAP[size]} ${textClassName}`}
      >
        AGENTIC&nbsp;FUTUREPATH&nbsp;AI
      </span>
    );
  }

  const markSize = SIZE_MAP[size] || SIZE_MAP.md;

  return (
    <span data-testid="brand-logo" className={`inline-flex items-center gap-2.5 ${className}`}>
      <img
        src="/branding/futurepath-logo.png"
        alt="Agentic FuturePath AI"
        className={`${markSize} object-contain drop-shadow-[0_0_12px_rgba(59,130,246,0.45)]`}
      />
      {withWordmark && (
        <span
          className={`font-bold tracking-[0.18em] bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-500 bg-clip-text text-transparent ${TEXT_SIZE_MAP[size]} ${textClassName}`}
        >
          AGENTIC&nbsp;FUTUREPATH&nbsp;AI
        </span>
      )}
    </span>
  );
}
